"use strict";
/* @ngInject */
function groupsInitService(userService, groupsService, institutionService, studyProgramsService, navigationMenuService, featureService, userSessionService, $q, preferenceService, layoutInitService) {
    function isDistrictUserAccessingDistrict(currentUser, tenantId) {
        return currentUser.districtUser && tenantId === currentUser.tenantId;
    }
    function populateNavBar(navigationMenu) {
        userSessionService.setNavigationMenu(navigationMenu);
    }
    function populateFooter(currentUser, institution) {
        var layoutUser = {
            firstName: currentUser.firstName,
            lastName: currentUser.lastName,
            highSchoolName: institution.name
        };
        userSessionService.setLayoutUser(layoutUser);
    }
    function saveDistrictPreferenceForSchool(preferenceData) {
        var value = !preferenceData.preferences ||
            !preferenceData.preferences.districtManagedDefaultGroups;
        userSessionService.setTenantManagingDefaults(value);
    }
    return function (tenantId) {
        var initData = {
            district: false,
            districtAdmin: false,
            currentUser: void 0,
            tenantId: tenantId
        };
        return userService.get().then(function (currentUser) {
            initData.currentUser = currentUser;
            if (currentUser.preferences) {
                var hideModal = currentUser.preferences.testprepWelcomeModal === false;
                if (hideModal) {
                    userSessionService.setHideWelcomeModal();
                }
            }
            var togglesPromise = featureService();
            var studyProgramsPromise = studyProgramsService.getSubscriptionStudyPrograms(tenantId)
                .then(function (subscriptionStudyPrograms) {
                userSessionService.setSubscriptionStudyPrograms(subscriptionStudyPrograms);
            });
            if (isDistrictUserAccessingDistrict(currentUser, tenantId)) {
                initData.district = true;
                initData.districtAdmin = currentUser.isDistrictAdmin();
                if (initData.districtAdmin) {
                    userSessionService.setDistrictMode(tenantId, true);
                }
                var navMenuPromise = navigationMenuService(tenantId, initData.district).then(populateNavBar);
                var institutionPromise = institutionService(tenantId).then(function (institution) {
                    initData.institution = institution;
                    populateFooter(currentUser, institution);
                });
                return $q.all([togglesPromise, studyProgramsPromise, navMenuPromise, institutionPromise]).then(function () {
                    userSessionService.setTenantManagingDefaults(true);
                    layoutInitService(initData);
                    return initData;
                });
            }
            else {
                userSessionService.setDistrictMode(tenantId, initData.district);
                var navMenuPromise = navigationMenuService(tenantId).then(populateNavBar);
                var groupsPromise = groupsService.getAll(tenantId).then(function (groups) {
                    initData.groups = groups;
                });
                var preferencePromise = institutionService(tenantId).then(function (institution) {
                    initData.institution = institution;
                    populateFooter(currentUser, institution);
                    if (institution.parent) {
                        return preferenceService.getInstitutionPreference(institution.parent)
                            .then(saveDistrictPreferenceForSchool);
                    }
                    else {
                        userSessionService.setTenantManagingDefaults(true);
                    }
                });
                return $q
                    .all([togglesPromise, studyProgramsPromise, navMenuPromise, preferencePromise, groupsPromise])
                    .then(function () {
                    layoutInitService(initData);
                    return initData;
                });
            }
        });
    };
}
exports.groupsInitService = groupsInitService;



/** WEBPACK FOOTER **
 ** ./app/groups/groups-init/groups-init.service.ts
 **/